import {createAsyncAction, } from 'typesafe-actions';

import * as types from './types';

export const fetchExamples = createAsyncAction(
    types.FETCH_EXAMPLES_REQUEST,
    types.FETCH_EXAMPLES_SUCCEEDED,
    types.FETCH_EXAMPLES_FAILED,
)<void, number[], Error>();
